import PrinterInformation from '@/models/PrinterInformation/PrinterInformation';

export default class PrinterInformationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.printerIpAddress = '';
		this.printerPort = '';
		this.isMobilePrinter = false;
		this.isDisabled = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			printerIpAddress : '0',
			printerPort : '0',
			isMobilePrinter : '0',
			isDisabled : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}